<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
export default {
  name: 'approval',
  components: {
    FormWizard,
    TabContent
  },
  data () {
    return {
      dialogVisible: false,
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem illo, eveniet eius cum adipisci minima eos possimus quas, maxime omnis velit voluptas sit quia minus necessitatibus harum quam, voluptatum dicta!',
      dynamicTags: ['Tømrer', 'Tegltag', 'Loft', 'Isolering', 'Egetræsgulv'],
      inputVisible: false,
      inputValue: ''
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  methods: {
    gotoRegistration () {
      this.$router.push('/klima/registration')
    },
    onComplete () {
      this.dialogVisible = true
      /*  let obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',
        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      }
      this.$refs.simplert.openSimplert(obj) */
    },
    isLastStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    isFirstStep () {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isFirstStep
      }
      return false
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    goToNps () {
      this.dialogVisible = false
      this.$router.push('/approval/nps')
    }
  },
  computed: {}
}
</script>
<template>
<div class="animated fadeIn">
    <!-- mobile view -->
    <div class="clearfix fullHeight p2 pb4 mb2" v-if="showMobile">
      <div class="clearfix mt3 pt2 pb3 highlights">
        <form-wizard ref="wizard" title="" subtitle="" shape="square" finishButtonText="Bekræft" color="" error-color="#ff4949" class="px1">
          <tab-content title="1">
            <div class="clearfix">
              <p class="h4 gibson semi-bold primarycolor line-height-3 mb2">Hej Cuatomer Name</p>
              <p class="h5 regular gibson darkblue line-height-golden">
                Efter aftale fremsendes hermed opgave til din godkendelse inden den sendes i udbud.
              </p>
              <p class="h5 regular gibson darkblue line-height-golden">
                Det er vigtigt at du dobbelttjekker informationerne, så du på den måde kan få det bedste resultat hurtigst muligt.
              </p>
              <p class="h5 regular gibson darkblue line-height-golden">
                Så snart opgaven er godkendt fra din side, vil opgaven blive lagt i udbud på platformen, således at selvstændige virksomheder kan byde på opgaven.
              </p>
            </div>
          </tab-content>
          <tab-content title="2">
            <div class="clearfix">
              <p class="h4 gibson semi-bold primarycolor line-height-3 mb2">Opgavens beskrivelsse</p>
              <textarea name="description" id="" class="col-12 p2 darkblue line-height-golden h5 gibson border form-border regular lightgrey-background" v-html="description" style="min-height:240px;"></textarea>
              <span class="inline-block p1 h5 gibson darkblue flex justify-start items-center">
                <span>Ret beskrivelse</span>
                <span class="ml1"><i class="el-icon-edit"></i></span>
              </span>
            </div>
          </tab-content>
          <tab-content title="3">
            <div class="clearfix">
              <p class="h4 gibson semi-bold primarycolor line-height-3 mb2">Opgavens beskrivelsse</p>
              <textarea name="description" id="" class="col-12 p2 darkblue line-height-golden h5 gibson border form-border regular lightgrey-background" v-html="description" style="min-height:240px;"></textarea>
              <span class="inline-block p1 h5 gibson darkblue flex justify-start items-center">
                <span>Ret beskrivelse</span>
                <span class="ml1"><i class="el-icon-edit"></i></span>
              </span>
            </div>
          </tab-content>
          <tab-content title="4">
            <div class="clearfix approvalTags">
              <p class="h4 gibson semi-bold primarycolor line-height-3 mb2">Faggruppe tags</p>
              <div class="py1"></div>
              <el-tag effect="dark" color="rgb(25, 163, 192)" :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                <span class="white gibson h5 m0 p0 line-height-1">{{tag}}</span></el-tag>
              <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
            </div>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div v-if="props.activeTabIndex == 0 && !props.isLastStep" class="col-12 px0 flex flex-column justify-center items-center">
              <wizard-button @click.native="props.nextTab()" class="action-button p2 mt2 flex justify-center items-center col-6 mx-auto not-rounded border-none">
                <span class="h4 gibson line-height-1 m0 p0">Kom i gang</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </wizard-button>
            </div>
            <div v-if="!props.activeTabIndex == 0 && !props.isLastStep" class="col-12 px0 flex flex-column justify-center items-center">
              <wizard-button @click.native="props.nextTab()" class="action-button p2 mt2 flex justify-center items-center col-6 mx-auto not-rounded border-none">
                <span class="h4 gibson line-height-1 m0 p0">Næste</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </wizard-button>
            </div>
            <div v-if="props.isLastStep" class="col-12 px0 mt2 flex justify-center items-center">
              <wizard-button type="button" @click.native="onComplete" class="action-button gibson p2 col-6 mx-auto flex justify-center items-center not-rounded border-none">
                <span class="h4 gibson line-height-1 m0 p0">
                  {{props.isLastStep ? 'Godkend' : 'Næste'}}
                </span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </wizard-button>
            </div>
          </template>
        </form-wizard>
      </div>
      <div class="py4"></div>
      <el-dialog v-if="showMobile" :fullscreen=true :show-close=false title="" :visible.sync="dialogVisible" width="80%">
        <div class="clearfix">
          <p class="h4 regular darkblue gibson line-height-golden">
            Når du godkender opgaven sendes den i udbud på en halv-offentlig platform hvor alle virksomheder kan byde på opgaven - disse virksomheder er ikke får godkendt af Håndværker.dk, hvorfor vi anbefaler, at man undersøger firmaerne, f.eks. om de er medlem af de garantiordninger, om de har de faguddannelser de angiver, ved at tjekke f.eks. Byggaranti.dk eller Sikkerhedsstyrelsens Autorisationsregister.
          </p>
          <p class="h4 regular darkblue gibson line-height-golden">
            Når du trykker “Bekræft” godkender du også, at Håndværker.dk ikke kan holdes til ansvar for eventuelle fejl og mangler i udførelsen af projektet. Hvis du som kunde er utilfreds med det udførte arbejde, er det udelukkende håndværkeren, der kan drages til ansvar for det udførte arbejde, ikke Håndværker.dk
          </p>
          <div class="py1"></div>
          <el-button class="action-button gibson line-height-1 p3 col-6 flex justify-center items-center not-rounded border-none" @click="goToNps()">
            <span class="h3 regular line-height-1 m0 p0">Bekræft</span>
            <span class="h3 line-height-1 p0 ml1"><i class="el-icon-right"></i></span>
          </el-button>
        </div>
        <span slot="footer" class="hide col-12 px0 flex justify-between"></span>
      </el-dialog>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<style lang="less">
.el-dialog__footer {
  padding: 0 20px!important;
}
.el-tag {
  border: 0!important;
  border-radius: 0!important;
  height: auto!important;
  padding: 10px 18px!important;
  margin-right: 10px;
}
.el-tag + .el-tag {
  margin-bottom: 10px;
}
.button-new-tag {
  height: 48px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  width:100%;
  background-color: rgba(178, 190, 195, 0.5);
  font-family: 'canada-type-gibson';
  font-size: 17px;
  color: rgba(0, 54, 69, 1.0);
}
.input-new-tag {
  width: 100%;
  vertical-align: bottom;
}
.vue-form-wizard {
  .action-button {
    background-color:#4DCF61!important;
    padding:1.25rem!important;
  }
}
.vue-form-wizard .wizard-header {
  height:0;
  padding:0;
}
.progress {
    background-color: rgba(178, 190, 195, 0.6);
}
.itemSelect {
    input[type="radio"] {
      display: none;
    }
    input[type="radio"] + label {
      display: block;
      background-color: white;
      transition: background-color 0.5s ease;
    }
    .yes {
        color: rgba(77, 207, 85, 1.0);
        border: 2px solid currentColor;
    }
    .no {
        color: rgba(207, 0, 15, 1.0);
        border: 2px solid currentColor;
    }
    input[type="radio"]:checked + label.yes {
      background-color: rgba(77, 207, 85, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
    input[type="radio"]:checked + label.no {
      background-color: rgba(207, 0, 15, 1.0);
      transition: background-color 0.5s ease;
      color: white;
      svg {
        fill: white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// approval.vue?7842ee89